import gql from "graphql-tag";

export const MY_TIMESHEET_UPDATE_CLIENT = gql`
  mutation updateMySheetClient(
    $_id: String!
    $name: String!
    $color: String
    $description: String!
    $validFrom: Date
    $validTo: Date
  ) {
    updateMySheetClient(
      _id: $_id
      name: $name
      color: $color
      description: $description
      validFrom: $validFrom
      validTo: $validTo
    ) {
      _id
      name
      description
      color
      validFrom
      validTo
      createdAt
      createdBy
      modifiedAt
      modifiedBy
      isDeleted
    }
  }
`;
